import React from 'react';
import { createRoot } from 'react-dom/client';
import { getDocument } from '@atlaskit/browser-apis';
import { App } from './ui/App';
import { initSentry } from '@atlassian/twg-microsite-experience';
import { consumeShowcaseUrlOverride } from '@atlassian/twg-microsite-experience/graph-explorer/showcase-mode';
import { initUFO } from './analytics/react-ufo/initUFO';
import { initializeFeatureGatesAnonymous } from './feature-flags';

// Initialise Sentry before rendering the app.
// Disabled in dev environments (localhost / development / local).
initSentry();

// Initialise React UFO before rendering so the React Profiler subscription
// is in place when the first commit happens.
initUFO();

// Kick off an anonymous bootstrap of the Statsig feature-gate client so
// that `fg(...)` resolves against real values for **both** logged-out
// and logged-in audiences. This also installs the
// `setBooleanFeatureFlagResolver` exactly once — gates listed in
// `ALWAYS_ON_GATES` gates are honoured even if
// Statsig is still in flight. We intentionally do not `await` this
// promise here so the React tree starts rendering immediately; the
// promise is awaited again inside `initializeFeatureGates` when the
// user logs in, so re-identification cannot race the anonymous init.
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
void initializeFeatureGatesAnonymous();

// Turn `?graph=showcase` into a session-scoped override and strip it from the
// address bar, so a demo URL does not have to stay on screen. Runs before
// `root.render` so the explorer's first mount already sees the resolved value —
// it reads showcase mode once and would otherwise keep the pre-strip answer.
consumeShowcaseUrlOverride();

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
